<template>
  <div>
    <!-- <template class="mt-0">
      <advertisement-top-banner-text />
    </template>
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template> -->
    <div else>
      <sections-slider
        v-if="$route.params.items == `Most Popular`"
        :list="itemSuggestions"
        :subTitle="$route.params.items"
        :showTitle="true"
        :hasBackground="false"
        :hasButton="false"
        :withoutSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item :itemNoBg="true" :product="listItem" :incrementDecrementKey="true"></items-item>
          </div>
        </template>
      </sections-slider>

      <sections-slider
        v-if="$route.params.items == `Daily Essentials`"
        :list="newArrivals"
        :subTitle="$route.params.items"
        :showTitle="true"
        :hasBackground="false"
        :hasButton="false"
        :withoutSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item :itemNoBg="true" :product="listItem" :incrementDecrementKey="true"></items-item>
          </div>
        </template>
      </sections-slider>

      <sections-slider
        v-if="$route.params.items == `Recommended Stores`"
        :list="recommendedStores"
        :subTitle="$route.params.items"
        :hasBackground="false"
        :showTitle="true"
        :hasButton="false"
        :withoutSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box product-listing-div">
            <router-link
              style="text-decoration: none; color: inherit"
              :to="{
                name: `shopDetails`,
                params: {
                  id: listItem._id,
                  name: listItem.office.officeName,
                },
              }"
            >
              <items-item :itemWhiteBg="true" :product="listItem"> </items-item>
            </router-link>
          </div>
        </template>
      </sections-slider>

      <sections-slider
        v-if="$route.params.items == `Whats Trending`"
        :list="whatsTrending"
        :subTitle="$route.params.items"
        :showTitle="true"
        :hasBackground="false"
        :hasButton="false"
        :withoutSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item :itemNoBg="true" :product="listItem" :incrementDecrementKey="true"></items-item>
          </div>
        </template>
      </sections-slider>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  computed: {
    ...mapState({
      itemSuggestions: (state) => state.healthCare.itemSuggestions,
      newArrivals: (state) => state.healthCare.newArrivals,
      recommendedStores: (state) => state.healthCare.recommendedStores,
      whatsTrending: (state) => state.healthCare.trendingItems,
    }),
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(
      "healthCare/fetchAllItems",
      this.$route.params.market
    );
    this.isLoading = false;
  },
};
</script>

